const campoEsValido = ({ campoAValidar }) => { 
    let esValido = false
    if(typeof campoAValidar === 'string' || campoAValidar instanceof String) {
        // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
        if (campoAValidar != null && campoAValidar != undefined && campoAValidar != '' && campoAValidar.replace(/\s/g, '').length) {
            esValido = true;
        }
    }
    else if (typeof campoAValidar === 'number' || campoAValidar instanceof Number) {
        // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
        if (campoAValidar != null && campoAValidar != undefined && campoAValidar > 0) {
            esValido = true;
        }
    }
    else if (typeof campoAValidar === 'array' || campoAValidar instanceof Array) {
        // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
        if (campoAValidar != null && campoAValidar != undefined && campoAValidar.length > 0) {
            esValido = true;
        }
    }
    else {
        if (campoAValidar != null && campoAValidar != undefined) {
            esValido = true;
        }
    }
    return esValido;
}

const manipularVisualizacionModal =  ({ idModal, mostrar }) => { 
    const ACCION = (mostrar) ? 'show' : 'hide';
    $('#' + idModal).modal(ACCION);
}

const convertirCadenaAMayusculas = ({ cadena }) => {
    let cadenaConFormato = '';
    if(campoEsValido({ campoAValidar: cadena })) {
        cadenaConFormato = cadena.toUpperCase().trim();
    }
    return cadenaConFormato;
};

const esLaMismaCadena = ({ cadenaInicial, compararCon }) => { 
    const CADENA = convertirCadenaAMayusculas({ cadena: cadenaInicial });
    const COMPARAR_CON = convertirCadenaAMayusculas({ cadena: compararCon });
    console.log({ CADENA }, { COMPARAR_CON });
    return (CADENA === COMPARAR_CON);;
}

import enumeraciones from '@/../static/js/enumeraciones'
const areasAFiltrarParaDireccion = ({ areaDireccion, conDireccion }) => {
    let areas = {};
    switch (areaDireccion) {
        case enumeraciones.sinoj.direccionesNotificadores.Civiles:
            areas.elementosAOmitir =  [96,97,103];            
            if(!conDireccion)
                Array.prototype.push.apply(areas.elementosAOmitir, [36]);
          break;
        case enumeraciones.sinoj.direccionesNotificadores.Laborales:
            areas.elementosAConservar = [96,97,32];
            if(conDireccion)
                Array.prototype.push.apply(areas.elementosAConservar, [103]);
            else
                areas.elementosAOmitir =  [103];
          break;  
        case enumeraciones.sinoj.direccionesNotificadores.MixtoJesusMaria:
            areas.elementosAConservar = [29];
          default:            
          break;
    }
    return areas;
}

export { campoEsValido, manipularVisualizacionModal, convertirCadenaAMayusculas, esLaMismaCadena, areasAFiltrarParaDireccion };


// WEBPACK FOOTER //
// ./src/components/SINOJ/Comun/Funciones/validaciones.js